import { useContext, useMemo } from "react";
import { ToastContext } from "@/contexts/toast-context";

/**
 * useToast — 전역 토스트 푸시.
 *   const toast = useToast();
 *   toast.success("적용 완료");
 *   toast.error("저장 실패");
 *   toast.info("...");
 */
export function useToast() {
  const ctx = useContext(ToastContext);
  return useMemo(
    () => ({
      success: (text: string, durationMs?: number) => ctx?.push("ok", text, durationMs),
      error: (text: string, durationMs?: number) => ctx?.push("error", text, durationMs),
      info: (text: string, durationMs?: number) => ctx?.push("info", text, durationMs),
    }),
    [ctx],
  );
}
